<div class="comps-filter-container">
  <div
    nz-col
    id="currency-filter"
    class="comp-currency-filter filter-holder"
    style="width: 78px"
  >
    <va-currency-select
      size="small"
      selectWidth="78"
      labelPlacement="top"
      [selectedCurrency]="selectedCurrency"
      [bottomBorderView]="true"
      [apiEP]="apiEP"
      apiUrl="/api/get_available_currencies"
      (onChange)="onCurrencyChange($event)"
    >
    </va-currency-select>
  </div>
  <!-- Year Type Filter -->
  <!-- <div
    nz-col
    [ngStyle]="{ width: compType === 'TimeSeries' ? '198px' : '114px' }"
    class="filter-holder"
  >
    <app-comps-year-type-filter
      [filterData]="filterData"
      (saveYearType)="saveCompsYearType($event)"
      (setPeriod)="setCompsPeriod($event)"
      [compType]="compType"
      [createComp]="false"
    ></app-comps-year-type-filter>
  </div> -->
  <div class="comp-period-filter filter-holder">
    <va-period-filter
      [periodData]="filterData.yearType ? filterData.yearType : undefined"
      [disabled]="!filterData || !updateMetaReady || !metaReady"
      (onApply)="handlePeriodApply($event)"
      [filterWidthVariation]="compType === 'TimeSeries' ? 3 : 1"
      [dataAvailable]="periodsWithAvailableData"
    ></va-period-filter>
  </div>

  <!-- Data view Filter -->
  <div nz-col class="datareview-filter filter-holder" style="width: 123px">
    <label class="filter-label">Data/Revisions</label>
    <button
      nz-button
      nz-popover
      nzPopoverTrigger="click"
      [nzPopoverContent]="contentTemplate"
      nzPopoverPlacement="bottomLeft"
      [(nzPopoverVisible)]="dataViewFilterVisible"
      (nzPopoverVisible)="popoverChange()"
      class="filter-btn"
      style="width: 100%"
    >
      <span [innerHTML]="selectedDataView"></span>
      <span></span>
      <i nz-icon [nzType]="popoverOpen ? 'up' : 'down'" class="arrow"></i>
    </button>

    <ng-template #contentTemplate>
      <ul nz-menu class="list-style revision-option-list">
        <li nz-menu-item>
          <nz-checkbox-group
            [(ngModel)]="checkOptions"
            (ngModelChange)="chkboxOptChange()"
          ></nz-checkbox-group>
        </li>
        <li nz-menu-divider></li>
        <li nz-menu-item style="height: 90px">
          <nz-radio-group
            [(ngModel)]="radioValue"
            class="radio"
            (ngModelChange)="radioValChange()"
          >
            <label nz-radio nzValue="1m" class="radio-opt"
              >&Delta; 1 month</label
            >
            <label nz-radio nzValue="3m" class="radio-opt"
              >&Delta; 3 months</label
            >
            <label nz-radio nzValue="custom" class="radio-opt"
              ><span
                >&Delta;
                <nz-date-picker
                  [(ngModel)]="customDate"
                  [nzDisabledDate]="disabledCustomDate"
                  (ngModelChange)="onDateChange()"
                  nzPlaceHolder="Custom Days"
                  [ngStyle]="{
                    border: 'none',
                    'border-bottom': inValidCustomDate
                      ? '1px solid red'
                      : '1px solid #979797'
                  }"
                ></nz-date-picker> </span
              ><i
                nz-icon
                nzType="exclamation-circle"
                .
                nzTheme="outline"
                style="color: red"
                *ngIf="inValidCustomDate"
              ></i
            ></label>
          </nz-radio-group>
        </li>
        <li nz-menu-divider></li>
        <li class="buttons">
          <div
            class="err-msg-holder"
            *ngIf="invalidDataview"
            style="width: 110px; line-height: 1"
          >
            <i
              nz-icon
              nzType="exclamation-circle"
              nzTheme="outline"
              style="color: red"
            ></i>
            <span class="err-msg">{{ dvErrMsg }}</span>
          </div>
          <div class="button-container">
            <button class="va-button mr-8 reset-button" (click)="onResetDataView()">
              Reset
            </button>
            <button
              class="va-button va-button--primary"
              (click)="applyDataView()"
            >
              Apply
            </button>
          </div>
        </li>
      </ul>
    </ng-template>
  </div>
  <!-- Source Filter -->
  <div
    nz-col
    id="source-filter"
    class="filter-holder"
    [ngStyle]="{
      'max-width':
        currentTabType === 'user_tabs' ? '190px' : 'calc(100% - 300px)',
      'min-width': '150px'
    }"
  >
    <label class="filter-label">Source</label>
    <nz-select
      [(ngModel)]="selectedSource"
      class="filter"
      style="width: 100%"
      nzSize="small"
      (ngModelChange)="onSourceChange($event)"
      [nzDropdownClassName]="'select-dropdown-style'"
      nzBorderless
    >
      <ng-container *ngFor="let source of sources">
        <nz-option [nzValue]="source" [nzLabel]="source"></nz-option>
      </ng-container>
    </nz-select>
  </div>
</div>
